import { Dispatch } from 'redux';

import { requestHandler } from '../../../api';

export const getCachedBuro = async (dispatch: Dispatch, businessId: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/buro/${businessId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBuroHistory = async (
  dispatch: Dispatch,
  businessId: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/buro/${businessId}/history`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBuroByDate = async (
  dispatch: Dispatch,
  businessId: string,
  date: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/buro/${businessId}/date/${date}`,
    dispatch,
  });
  if (response) return response.data;
};
